import dayjs from 'dayjs';
export const GetParams = (startDate,endDate,searchValue) => {
    const params = {};
    if (startDate) {
        params.startDate = dayjs(startDate, 'DD/MM/YY').format('DD/MM/YY');
    }
    if (endDate) {
        params.endDate = dayjs(endDate, 'DD/MM/YY').format('DD/MM/YY');
    }
    if (searchValue) {
        params.search = searchValue.toLowerCase();
    }
    return params;
}

  const formatWhatsAppText = (txt) => {
    // Remove triple and single backticks, but do not style
    txt = txt.replace(/```([\s\S]+?)```/g, '$1');
    txt = txt.replace(/`([^`]+?)`/g, '$1');
    // Bold: *text* (not surrounded by spaces or punctuation)
    txt = txt.replace(/(^|[^\w*])\*([^\s*][^*]*[^\s*])\*(?!\w)/g, '$1<b>$2</b>');
    // Italic: _text_ (not surrounded by spaces or punctuation)
    txt = txt.replace(/(^|[^\w_])_([^\s_][^_]*[^\s_])_(?!\w)/g, '$1<i>$2</i>');
    // Strikethrough: ~text~ (not surrounded by spaces or punctuation)
    txt = txt.replace(/(^|[^\w~])~([^\s~][^~]*[^\s~])~(?!\w)/g, '$1<s>$2</s>');
    // Line breaks
    txt = txt.replace(/\n/g, '<br/>');
    return txt;
  };
export const renderBody = (text, dynamicValues) => {
    //console.log('renderBody called with:', { text, dynamicValues }); // Debug log
    
    if (!text) return <span></span>;

    // 1. Replace template variables with dynamic values first
    let processedText = text;
    if (dynamicValues && dynamicValues.length > 0) {
        // console.log('Processing dynamic values...'); // Debug log
        // Replace {{1}}, {{2}}, etc. with corresponding values from dynamicValues array
        processedText = text.replace(/\{\{(\d+)\}\}/g, (match, number) => {
            const index = parseInt(number) - 1; // Convert 1-based to 0-based index
            const replacement = dynamicValues[index] || match;
            return replacement; // Use original if no value found
        });
    }
    
    // console.log('Processed text:', processedText); // Debug log

    // 2. Apply WhatsApp formatting
    let html = formatWhatsAppText(processedText);

    // 3. Replace URLs in the formatted HTML with <a> tags, preserving formatting
    const urlRegex = /((https?:\/\/|www\.)[^\s<]+)/g;
    html = html.replace(urlRegex, (url) => {
        let href = url;
        if (!/^https?:\/\//i.test(url)) {
            href = 'https://' + url;
        }
        return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="color:#34b7f1;text-decoration:underline;word-break:break-all;">${url}</a>`;
    });

    return <span dangerouslySetInnerHTML={{ __html: html }} />;
};